var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchAgencyPublisherBySourceId } from "../api/publisherService";
/**
 * The agency publisher with the given sourceId. Every lookup of a publisher by
 * its sourceId shares this one query key, so a page that needs the same
 * publisher in several places (filter label, applied filter, auto-fill) fetches
 * it once.
 *
 * @param sourceId sourceId of the publisher; nothing is fetched without one
 * @param retry whether a failed lookup is retried (react-query default) — off
 *   where a search waits for the answer
 */
export var usePublisherBySourceId = function (sourceId, retry) {
    if (retry === void 0) { retry = true; }
    var ky = useOkapiKy();
    return useQuery(["publisherBySourceId", sourceId], function () { return fetchAgencyPublisherBySourceId(ky, sourceId); }, __assign({ enabled: !!sourceId, staleTime: Infinity }, (retry ? {} : { retry: false })));
};
